<template>
  <div>
    <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="ID">
        <el-input v-model.number="searchData.id" size="mini" />
      </el-form-item>
      <el-form-item label="邀请人">
        <el-input v-model.number="searchData.invite_id" size="mini" />
      </el-form-item>
      <el-form-item label="微信昵称">
        <el-input v-model.number="searchData.nickname" size="mini" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handlerSearch">
          查找
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="agentList" v-loading="loading">
      <el-table-column prop="user_id" width="70px" label="ID">
        <template slot-scope="scope">
          <el-link
            :href="'#/agent/detail/' + scope.row.user_id"
            type="primary"
            target="_blank"
            >{{ scope.row.user_id }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="user_id" width="50px">
        <template slot-scope="s">
          <el-image
            :src="s.row.avatar || ''"
            style="width: 40px; height: 40px;"
          />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="微信昵称">
        <template slot-scope="scope">
          <el-link
            :href="'#/agent/detail/' + scope.row.user_id"
            type="primary"
            target="_blank"
            >{{ scope.row.nickname }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="unionid" label="unionid" />
      <el-table-column prop="clients" label="客户数" />
      <el-table-column prop="invite_id" label="邀请人" />
      <el-table-column prop="cid" label="渠道号" />
      <el-table-column prop="last_login" width="150px" label="最后登陆" />
      <el-table-column prop="time" width="150px" label="创建时间" />
      <el-table-column prop="companyName" label="所属公司" />
      <el-table-column prop="subscribe" label="公众号" :formatter="formatter" />
      <el-table-column
        prop="continue_nums"
        width="150px"
        label="连续打卡天数"
      />
      <el-table-column prop="level" width="100px" label="VIP等级" />
      <el-table-column prop="vcard_id" label="名片" width="180px">
        <template slot-scope="scope">
          <el-button
            type="info"
            size="mini"
            v-if="scope.row.vcard"
            @click="handleVerifyUser(scope.row.user_id, scope.row.vcard)"
            >名片
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" width="80px">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="clickRemarks(scope.row.user_id, scope.row.remarks)"
          >
            备注
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="showSetVcard">
      <el-form ref="searchForm" :model="dataSetVcard">
        <el-form-item label="姓名">
          <el-input
            v-model="dataSetVcard.vcard.name"
            size="mini"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="dataSetVcard.vcard.mobile"
            size="mini"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="微信名">
          <el-input
            v-model="dataSetVcard.vcard.wechat_name"
            size="mini"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="公司">
          <el-input
            v-model="dataSetVcard.vcard.company"
            size="mini"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="valid" label="状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="mini" @click="subVerify()"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showRemarks">
      <el-input
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        v-model="textarea"
      >
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRemarks = false">取 消</el-button>
        <el-button type="primary" @click="updateRemarks">确 定</el-button>
      </div>
    </el-dialog>
    <page-bar
      :currentPageCount="agentList.length"
      @page-changed="loadData"
    ></page-bar>
  </div>
</template>

<script>
import PageBar from "../ui/PageBar";
import request from "../../api/request";

export default {
  name: "AgentList",
  components: {
    PageBar
  },
  data() {
    return {
      showSetVcard: false,
      showRemarks: false,
      dataSetVcard: {
        vcard: {}
      },
      currentUserId: "",
      valid: "",
      vcard_id: "",
      textarea: "",
      agentList: [],
      currentRange: [],
      loading: false,
      options: [
        {
          value: 0,
          label: "关闭"
        },
        {
          value: 1,
          label: "开启"
        }
      ],
      searchData: {},
      filter: {},
      companyOptionsData: {}
    };
  },
  created() {
    this.loadData([0, 10]);
  },
  methods: {
    subVerify: function() {
      request.agent
        .post("vcard_set_valid", {
          user_id: this.dataSetVcard.user_id,
          valid: this.valid == 1 ? true : false,
          vcard_id: this.vcard_id
        })
        .then(() => {
          this.$message.success("提交成功");
        })
        .finally(() => {
          this.showSetVcard = false;
          this.dataSetVcard = {};
          location.reload();
        });
    },
    clickRemarks(id, remarks) {
      this.showRemarks = true;
      this.currentUserId = id;
      this.textarea = remarks;
    },
    formatter(r, c, v) {
      return v ? "关注" : "未关注";
    },
    async loadData(range) {
      let tableList = [];
      this.currentRange = range;
      request.agent
        .post("agent_get_list", {
          filter: this.filter,
          range: range,
          sort: [{ field: "id", reverse: true }]
        })
        .then(r => {
          let companyOptionsData = [];
          request.product
            .post("get_doc_define", {
              category: "verify_company"
            })
            .then(resp => {
              if (resp.status === 0) {
                companyOptionsData = resp.data;
                tableList = r.data.list.map(item => {
                  return {
                    ...item,
                    companyName: companyOptionsData[item.company]
                  };
                });
                this.agentList = tableList;
                this.loading = false;
              }
            });
        });
    },
    handlerSearch: function() {
      let filter = {};
      if (this.searchData.id) {
        filter.id = this.searchData.id;
      }
      if (this.searchData.invite_id) {
        filter.invite_id = this.searchData.invite_id;
      }
      if (this.searchData.nickname) {
        filter.nickname = this.searchData.nickname + "";
      }
      if (
        this.searchData.id &&
        (this.searchData.invite_id || this.searchData.nickname)
      ) {
        this.$alert("ID和(邀请人或微信昵称)不能同时搜索", "错误提示", {
          confirmButtonText: "确定"
        });
        // this.searchError();
        return;
      }
      (this.filter = filter), this.loadData([0, 10]);
    },
    async updateRemarks() {
      await request.agent.post("agent_update", {
        user_id: this.currentUserId,
        remarks: this.textarea
      });
      this.$message.success("提交成功");
      this.showRemarks = false;
      this.textarea = "";
      this.currentUserId = "";
      this.loadData(this.currentRange);
    },
    handleVerifyUser: function(id, vcard) {
      this.showSetVcard = true;
      this.dataSetVcard.user_id = id;
      this.dataSetVcard.vcard = vcard;
      this.valid = vcard.valid;
      this.vcard_id = vcard.vcard_id;
    }
  }
};
</script>
